import { render, staticRenderFns } from "./SidebarChallenges.vue?vue&type=template&id=16c3d18e&"
import script from "./SidebarChallenges.vue?vue&type=script&lang=js&"
export * from "./SidebarChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports